import { RECOMMENDATION_TYPES } from '@bingads-webui-campaign/recommendation-core';

// This is traditional reasons for reject single/multiple with multiple choices (log in aria).
export const reasonsMapping = {
  [RECOMMENDATION_TYPES.NEW_KEYWORD_OPPORTUNITY]: [
    'KwdDoNotAdopt',
    'KwdNotRelevant',
    'KwdHighSpend',
    'KwdOther',
  ],
  [RECOMMENDATION_TYPES.BROAD_MATCH_KEYWORD]: [
    'BmaDoNotAdd',
    'BmaNotRelevant',
    'BmaHighSpend',
    'BmaOther',
  ],
  [RECOMMENDATION_TYPES.REMOVE_CONFLICTING_NEGATIVE_KEYWORD]: [
    'RcnkwIntentional',
    'RcnkwRatherAdj',
    'RcnkwNotInterested',
    'RcnkwOther',
  ],
  [RECOMMENDATION_TYPES.REPAIR_ADS]: [
    'HaveAddressed',
    'PendingEditoria',
    'DynamicSearch',
    'NotLikeAdgroup',
    'AddressOutsideRecs',
    'RepairOther',
  ],
  [RECOMMENDATION_TYPES.REPAIR_KEYWORD]: [
    'HaveAddressed',
    'PendingEditoria',
    'DynamicSearch',
    'NotLikeAdgroup',
    'AddressOutsideRecs',
    'RepairOther',
  ],
  [RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS]: [
    'RsaNeedApprovalBeforeApply',
    'RSAHasCompetitorInfo',
    'RSATooSensitive',
    'RSAOutdated',
    'RSANotLikeWording',
    'RsaAddRecommendedAdsLater',
    'RsaNeedOptOutAAR',
    'RSAOther',
  ],
  [RECOMMENDATION_TYPES.FIX_AD_TEXT]: [
    'WIP',
    'WontFix',
    'ResolveOutsideAds',
    'RepairOther',
  ],
  [RECOMMENDATION_TYPES.FIX_AD_DESTINATION]: [
    'WIP',
    'WontFix',
    'ResolveOutsideAds',
    'RepairOther',
  ],
  [RECOMMENDATION_TYPES.SETUP_CONVERSION_TRACKING_OPPORTUNITY]: [
    'SetupConvDoItLater',
    'SetupConvNeedAssistance',
    'SetupConvWorking',
    'SetupConvCannotMakeChanges',
    'SetupConvUseOtherTool',
    'SetupConvNotRelevant',
    'RepairOther',
  ],
  [RECOMMENDATION_TYPES.TRENDING_QUERY]: [
    'KwdDoNotAdopt',
    'KwdNotRelevant',
    'KwdHighSpend',
    'KwdOther',
  ],
  [RECOMMENDATION_TYPES.MULTIMEDIA_ADS]: [
    'MmaNotAddToAdGroup',
    'MmaNotLikeImages',
    'MmaNotLikeHeadlinesOrAdText',
    'MmaBadCombinations',
  ],
  [RECOMMENDATION_TYPES.IMAGE_EXTENSION]: [
    'ImageAdExtNotAddToAdGroup',
    'ImageAdExtNotLikeImages',
    'ImageAdExtConcernQuality',
  ],
  [RECOMMENDATION_TYPES.REPAIR_MISSING_KEYWORD_PARAMS]: [
    'FixRepairMissingKeywordParamsFixItLater',
    'FixRepairMissingKeywordParamsDoNotLikeSuggestedParamValues',
    'FixRepairMissingKeywordParamsNotSignificant',
    'FixRepairMissingKeywordParamsAlreadyFixedThisIssue',
    'FixRepairMissingKeywordParamsOther',
  ],
  [RECOMMENDATION_TYPES.FIX_NO_IMPRESSION_BID]: [
    'FixNoImpressionBidSuggestTooHigh',
    'FixNoImpressionBidSuggestNotSignificant',
    'FixNoImpressionBidHaveAdjusted',
    'FixNoImpressionBidOther',
  ],
  [RECOMMENDATION_TYPES.IMPROVE_RESPONSIVE_SEARCH_ADS]: [
    'FixImproveResponsiveSearchAdsImproveLater',
    'FixImproveResponsiveSearchAdsNotSignificant',
    'FixImproveResponsiveSearchAdsDoNotLikeHeadlineDescription',
    'FixImproveResponsiveSearchAdsSpendIncreaseTooMuch',
    'FixImproveResponsiveSearchAdsOther',
  ],
  [RECOMMENDATION_TYPES.REPAIR_UNTARGETED_OFFER]: [
    'FixRepairUntargetedOfferNotRelevant',
    'FixRepairUntargetedOfferManageInconvenient',
    'FixRepairUntargetedOfferExcludedIntentionally',
    'FixRepairUntargetedOfferNotUnderstand',
    'FixRepairUntargetedOfferImprovementLater',
    'FixRepairUntargetedOfferOther',
  ],
  [RECOMMENDATION_TYPES.IMPROVE_MULTIMEDIA_ADS]: [
    'ImproveMultiMediaAdsImprovementLater',
    'ImproveMultiMediaAdsNotSignificant',
    'ImproveMultiMediaAdsNotLikeRecommendedImages',
    'ImproveMultiMediaAdsNotLikeRecommendedTextOrHeadlines',
    'ImproveMultiMediaAdsIncreaseMySpendTooMuch',
    'ImproveMultiMediaAdsOther',
  ],
  [RECOMMENDATION_TYPES.DSA_2_PMAX_MIGRATION]: [
    'DSA2PMaxMigrationNoApplyUntilAttributesReviewed',
    'DSA2PMaxMigrationUnsureRecommendedCampaignIsImprovement',
    'DSA2PMaxMigrationCreatePerformanceMaxCampaignByMyOwn',
    'DSA2PMAxMigrationOther',
  ],
  [RECOMMENDATION_TYPES.SYNDICATION_GAP]: [
    'SyndicationGapCannotDisplayOnMicrosoftAdsNetwork',
    'SyndicationGapNotInterestedOnEntireMicrosoftAdsNetwork',
    'SyndicationGapOther',
  ],
};

export const reasonsMappingNewI18n = {
  [RECOMMENDATION_TYPES.REPAIR_MISSING_KEYWORD_PARAMS]: {
    FixRepairMissingKeywordParamsFixItLater: _TL_('I will fix this issue later.'),
    FixRepairMissingKeywordParamsDoNotLikeSuggestedParamValues: _TL_('I don\'t like the suggested param values.'),
    FixRepairMissingKeywordParamsNotSignificant: _TL_('The estimates show no significant improvement.'),
    FixRepairMissingKeywordParamsAlreadyFixedThisIssue: _TL_('I have already fixed this issue.'),
    FixRepairMissingKeywordParamsOther: _TL_('Other'),
  },
  [RECOMMENDATION_TYPES.FIX_NO_IMPRESSION_BID]: {
    FixNoImpressionBidSuggestTooHigh: _TL_('The suggested bids are higher than expected.'),
    FixNoImpressionBidSuggestNotSignificant: _TL_('The suggestion shows no significant improvement.'),
    FixNoImpressionBidHaveAdjusted: _TL_('I have recently adjusted the bid.'),
    FixNoImpressionBidOther: _TL_('Other'),
  },
  [RECOMMENDATION_TYPES.IMPROVE_RESPONSIVE_SEARCH_ADS]: {
    FixImproveResponsiveSearchAdsImproveLater: _TL_('I will make the improvement later.'),
    FixImproveResponsiveSearchAdsNotSignificant: _TL_('The performance of responsive search ads show no significant improvement.'),
    FixImproveResponsiveSearchAdsDoNotLikeHeadlineDescription: _TL_('I don\'t like the suggested headlines or descriptions.'),
    FixImproveResponsiveSearchAdsSpendIncreaseTooMuch: _TL_('The estimated increase of spend by adopting the recommendation is too high.'),
    FixImproveResponsiveSearchAdsOther: _TL_('Other'),
  },
  [RECOMMENDATION_TYPES.REPAIR_UNTARGETED_OFFER]: {
    FixRepairUntargetedOfferNotRelevant: _TL_('The suggested campaigns do not align with my business goal.'),
    FixRepairUntargetedOfferManageInconvenient: _TL_('Managing a catch-all campaign is inconvenient.'),
    FixRepairUntargetedOfferExcludedIntentionally: _TL_('I want to exclude some product offers from my shopping campaign.'),
    FixRepairUntargetedOfferNotUnderstand: _TL_('I don\'t know why this has been recommended to me.'),
    FixRepairUntargetedOfferImprovementLater: _TL_('I\'ll create a catch-all shopping campaign later.'),
    FixRepairUntargetedOfferOther: _TL_('Other'),
  },
  [RECOMMENDATION_TYPES.IMPROVE_MULTIMEDIA_ADS]: {
    ImproveMultiMediaAdsImprovementLater: _TL_('I\'ll apply this recommendation later.'),
    ImproveMultiMediaAdsNotSignificant: _TL_('The recommendation doesn\'t improve my multimedia ad performance.'),
    ImproveMultiMediaAdsNotLikeRecommendedImages: _TL_('I don\'t like the recommended images.'),
    ImproveMultiMediaAdsNotLikeRecommendedTextOrHeadlines: _TL_('I don\'t like the recommended ad texts or headlines.'),
    ImproveMultiMediaAdsIncreaseMySpendTooMuch: _TL_('The recommendation will likely increase my spend too much.'),
    ImproveMultiMediaAdsOther: _TL_('Other'),
  },
  [RECOMMENDATION_TYPES.DSA_2_PMAX_MIGRATION]: {
    DSA2PMaxMigrationNoApplyUntilAttributesReviewed: _TL_('I don\'t want to apply the recommendation unless I can review the recommended attributes for the Performance Max campaign.'),
    DSA2PMaxMigrationUnsureRecommendedCampaignIsImprovement: _TL_('I\'m unsure that the recommended campaign will be an improvement.'),
    DSA2PMaxMigrationCreatePerformanceMaxCampaignByMyOwn: _TL_('I\'ll create my own Performance Max campaign.'),
    DSA2PMAxMigrationOther: _TL_('Other'),
  },
  [RECOMMENDATION_TYPES.SYNDICATION_GAP]: {
    SyndicationGapCannotDisplayOnMicrosoftAdsNetwork: _TL_('The ads from the selected ad groups cannot be displayed on the Microsoft Advertising Network.'),
    SyndicationGapNotInterestedOnEntireMicrosoftAdsNetwork: _TL_('I don\'t want the ads from the selected ad groups to be shown on the entire Microsoft Advertising Network.'),
    SyndicationGapOther: _TL_('Other'),
  },
};

export const reasonsMappingAutoApplyFeedback = [
  'NewAdsReviewAds',
  'NewAdsConcernQuality',
  'NewAdsConcernPerformance',
  'NewAdsOther',
];
